import React from 'react';
//style
import styles from 'src/asset/scss/style/user.comn.module.scss'
//comp
import Element from 'src/webapp/views/wrapper/Element';

export default function ButtonArea(props) {

    return (
        <Element tag={`div`} className={styles.buttonArea}>
            
        </Element>
    );
  }